import React, { useCallback, useEffect, useState } from "react";
import styles from "./JustPay.module.css";
import { useDispatch } from "react-redux";
import {
  copyLoanRequest,
  getLeadListByInstituteAndContact,
  resendLoanRequest,
  resetCopyLoanRequestSuccess,
  resetResendLoanRequestSuccess,
  resetSendLoanRequestSuccess,
  sendLoanRequest,
} from "../../pages/app/Nurture/service/nurtureSlice";
import { useSelector } from "react-redux";
import { MenuItem, Popover, Tooltip, IconButton } from "@mui/material";
import dots from "../../assets/images/unionDots.svg";
import eye from "../../assets/images/Vector.svg";
import CancelModalForJustPay from "./CancelModalForJustPay";

const JustPayLoan = ({ leadById }: any) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);

  const {
    sendLoanRequestSuccess,
    copyLoanRequestSuccess,
    resendLoanRequestSuccess,
    copyLoanRequestUrl,
  } = useSelector((state: any) => state.nurture);

  const handleLoanSubmitRequest = () => {
    const body = {
      enquiryId: leadById?.id,
    };
    dispatch<any>(sendLoanRequest(body));
  };

  const handleLoanResendSubmitRequest = () => {
    const body = {
      enquiryId: leadById?.id,
      actionType: "resendLink",
    };
    dispatch<any>(resendLoanRequest(body));
  };

  const handleLoanCopySubmitRequest = () => {
    const body = {
      enquiryId: leadById?.id,
      actionType: "copyLink",
    };
    dispatch<any>(copyLoanRequest(body));
  };

  const leadPopupApiCall = useCallback(
    (instituteId: string, phone: string | null, email: string | null) => {
      let data: any;
      if (instituteId) {
        if (phone) {
          data = {
            id: instituteId,
            phone: phone,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        } else if (email) {
          data = {
            id: instituteId,
            email: email,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        }
      }
    },
    [getLeadListByInstituteAndContact],
  );

  useEffect(() => {
    if (sendLoanRequestSuccess === true) {
      dispatch(resetSendLoanRequestSuccess());
      leadPopupApiCall(
        leadById?.instituteId,
        leadById?.studentContact,
        leadById?.studentEmail,
      );
    }
  }, [sendLoanRequestSuccess]);

  useEffect(() => {
    if (copyLoanRequestSuccess === true) {
      dispatch(resetCopyLoanRequestSuccess());
      navigator.clipboard.writeText(copyLoanRequestUrl?.data);
    }
  }, [copyLoanRequestSuccess]);

  useEffect(() => {
    if (resendLoanRequestSuccess === true) {
      dispatch(resetResendLoanRequestSuccess());
    }
  }, [resendLoanRequestSuccess]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleCancelOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCancelClose = () => {
    setAnchorEl(null);
  };

  const onClose = () => {
    setOpenModal(false);
  };

  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  return (
    <div style={{ position: "relative" }}>
      {leadById?.loanApplicationLinkSent === undefined ? (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            className={styles.buttonEnabled}
            style={{
              opacity:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? 0.5
                  : 1,
              cursor:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? "not-allowed"
                  : "pointer",
              pointerEvents:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? "none"
                  : "auto",
            }}
            onClick={
              !instituteData?.migrationStarted || !instituteData?.isMigrated
                ? handleLoanSubmitRequest
                : undefined
            }
          >
            Apply for loan
          </div>
          <div
            style={{
              opacity:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? 0.5
                  : 1,
              cursor:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? "not-allowed"
                  : "pointer",
              pointerEvents:
                instituteData?.migrationStarted || instituteData?.isMigrated
                  ? "none"
                  : "auto",
            }}
            onClick={
              !instituteData?.migrationStarted || !instituteData?.isMigrated
                ? () => setOpenModal(true)
                : undefined
            }
          >
            <img src={eye} alt="" className={styles.eyeButton} />
          </div>
        </div>
      ) : (
        <>
          {leadById?.loanApplicationLinkSent === true ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div className={styles.buttonDisabled}>Loan Application Sent</div>
              <div>
                <Tooltip
                  arrow
                  title={""}
                  PopperProps={{ style: { zIndex: 999999 } }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#101828",
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: "500",
                        padding: "8px 12px",
                        zIndex: "999999",
                        "& .MuiTooltip-arrow": {
                          color: "#101828",
                          zIndex: "999999",
                        },
                      },
                    },
                  }}
                >
                  <span>
                    <IconButton
                      aria-label="more"
                      id="long-button"
                      aria-controls={open ? "long-menu" : undefined}
                      aria-expanded={open ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleCancelOpen}
                      sx={{
                        width: "20px",
                        height: "20px",
                        border: "none",
                        borderRadius: "4PX",
                        background: "trasnarent",
                        "&:hover": {
                          background: "transparent",
                        },
                      }}
                    >
                      <img src={dots} alt="" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Popover
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCancelClose}
                  sx={{ zIndex: 999999 }}
                  PaperProps={{
                    style: {
                      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                      borderRadius: "4PX",
                      border: "1px solid #E4E4E7",
                      zIndex: 999999,
                    },
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: -5,
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    sx={{
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#667085",
                    }}
                    onClick={() => {
                      handleCancelClose();
                      handleLoanResendSubmitRequest();
                    }}
                  >
                    Resend link
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#667085",
                    }}
                    onClick={() => {
                      handleCancelClose();
                      handleLoanCopySubmitRequest();
                    }}
                  >
                    Copy link
                  </MenuItem>
                </Popover>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                className={styles.buttonEnabled}
                onClick={handleLoanSubmitRequest}
              >
                Apply for loan
              </div>
              <div
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                <img src={eye} alt="" className={styles.eyeButton} />
              </div>
            </div>
          )}
        </>
      )}
      <CancelModalForJustPay
        open={openModal}
        onClose={onClose}
        noButtonClick={onClose}
        yesButtonClick={onClose}
      />
    </div>
  );
};

export default JustPayLoan;
